import { FC, ReactElement } from 'react'

import { ConnectedDocuments } from '@/connectors'

export const DocumentsPage: FC = (): ReactElement => <ConnectedDocuments />
